import ButtonField from '@/components/form-control/ButtonField'
import { useTranslation } from '@/hooks/useTranslation'
import { DATA_TABLE_SOIL_SETUP } from '@/constant/common'
import { Stack, Typography } from '@mui/material'
import FooterSetup from '../../common/FooterSetup'
import MenuHeader from '../../common/MenuHeader'
import RightGoogleMapSmall from '../../common/RightGoogleMapSmall'
import SetUpLayout from '../../common/SetUpLayout'
import SoilTable from './SoilTable'

type Props = {}

const SoilData = (props: Props) => {
  const { t } = useTranslation()

  const handleClick = () => {

  }

  return (
    <SetUpLayout
      title='Soil'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMapSmall
      />}
      footer={<Stack p="25px 32px"><FooterSetup /></Stack>}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: "20px", lineHeight: "2.4" }}>{t('commonLabelsReviewSoilData')}</Typography>
        <Stack alignItems="center">
          <ButtonField
            startIcon={<></>}
            style={{
              height: '32px',
              minWidth: '89px',
              borderRadius: '5px',
            }}
            name="Done"
            onClick={handleClick}
          />
        </Stack>
      </Stack>
      <SoilTable rows={DATA_TABLE_SOIL_SETUP} />
    </SetUpLayout>
  )
}

export default SoilData